import {
    BUY,
    MAKE,
    LEARN,
    PRESERVE
} from '@/model/trendradar/stages'

export default {
    alternative: 'There are no macro-trends in this section',

    stages: {
        title: 'Macro-trends in this section',
        info: 'What does {stage} mean?',
        [MAKE]: {
            title: 'Make'
        },
        [BUY]: {
            title: 'Buy'
        },
        [LEARN]: {
            title: 'Learn'
        },
        [PRESERVE]: {
            title: 'Preserve'
        }
    }
}
